var __rspack_ns_object = JSON.parse('{"Copied":"Copié","Failed to copy":"Échec de la copie"}')